import { css } from 'aphrodite';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { getIntegrationProviderDisplayName } from '../../../models/utils/integrationUtils';
import { IProviderMigrationSummary } from '../../../queries/Admin/IntegrationsHealth';
import { Button } from '../../../web/components-v2/Button';
import { Pill } from '../../../web/components-v2/Pill';
import { CollapsibleProviderSection } from './CollapsibleProviderSection';
import { recentActivityUrl } from './integrationUrls';
import { styleSheet } from './styles';

export interface IFilteredMigrationProvider extends IProviderMigrationSummary {
	visiblePendingCount: number;
}

interface IProps {
	providers: IFilteredMigrationProvider[];
	expandGroups: boolean;
}

export const MigrationSection: React.FC<IProps> = ({ providers, expandGroups }) => (
	<>
		{providers.map(provider => (
			<CollapsibleProviderSection
				key={provider.provider}
				title={getIntegrationProviderDisplayName(provider.provider)}
				defaultOpen={expandGroups}
				statusChip={
					<>
						<span className={css(styleSheet.providerRatio)}>
							{provider.migratedCount} / {provider.migratedCount + provider.pendingCount} migrated
						</span>
						<Pill variant='tag' color='orange' label={`${provider.visiblePendingCount} needing`} size='small' />
					</>
				}
			>
				<table className={css(styleSheet.table)}>
					<colgroup>
						<col />
						<col className={css(styleSheet.colActions)} />
					</colgroup>
					<thead>
						<tr>
							<th className={css(styleSheet.th)}>Account</th>
							<th className={css(styleSheet.th)}>Actions</th>
						</tr>
					</thead>
					<tbody>
						{provider.pendingAccounts.length === 0 ? (
							<tr>
								<td className={css(styleSheet.td, styleSheet.mutedText)} colSpan={2}>
									{provider.visiblePendingCount} pending, but the account list wasn&apos;t returned.
								</td>
							</tr>
						) : null}
						{provider.pendingAccounts.map(account => {
							const url = recentActivityUrl(account.accountId, provider.provider);
							return (
								<tr key={`${account.accountId}-${provider.provider}`}>
									<td className={css(styleSheet.td)}>
										<Link className={css(styleSheet.accountLink)} to={url}>
											{account.companyName ?? account.accountId}
										</Link>
									</td>
									<td className={css(styleSheet.td)}>
										<Button asChild variant='secondary' size='sm' styles={[styleSheet.actionButton]}>
											<Link to={url}>View activity</Link>
										</Button>
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</CollapsibleProviderSection>
		))}
	</>
);
